import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Form from '../loginForm/form';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

const AuthCheck = ({ children, redirectTo = null, showModal = true, onAuthRequired = null }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const navigate = useNavigate();

  // Helper function to safely show the modal
  const showLoginModal = () => {
    const modalElement = document.getElementById('authModal');
    if (modalElement && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
      try {
        // Check if modal instance already exists
        let modal = bootstrap.Modal.getInstance(modalElement);
        if (!modal) {
          // Create new modal instance
          modal = new bootstrap.Modal(modalElement);
        }
        modal.show();
      } catch (error) {
        console.error('Error showing modal:', error);
      }
    }
  };

  // Effect to show modal when shouldShowModal is true and component is rendered
  useEffect(() => {
    if (shouldShowModal && !isLoading) {
      // Use setTimeout to ensure DOM is fully ready
      const timer = setTimeout(() => {
        showLoginModal();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [shouldShowModal, isLoading]);

  useEffect(() => {
    const checkAuth = () => {
      const user = localStorage.getItem('user');
      const token = localStorage.getItem('accessToken');
      
      if (user && token) {
        setIsAuthenticated(true);
        setShouldShowModal(false);
      } else {
        setIsAuthenticated(false);
        if (showModal) {
          setShouldShowModal(true);
        } else if (onAuthRequired) {
          // Call the callback instead of showing modal
          onAuthRequired();
        }
      }
      setIsLoading(false);
    };

    checkAuth();

    // Listen for login events
    const handleUserLogin = () => {
      setIsAuthenticated(true);
      setShouldShowModal(false);
      const modal = document.getElementById('authModal');
      if (modal && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
        try {
          const bsModal = bootstrap.Modal.getInstance(modal);
          if (bsModal) {
            bsModal.hide();
          }
        } catch (error) {
          console.error('Error hiding modal:', error);
        }
      }
    };

    // Listen for auth error events (401/Invalid Token)
    const handleAuthError = () => {
      setIsAuthenticated(false);
      if (showModal) {
        setShouldShowModal(true);
      } else if (onAuthRequired) {
        // Call the callback instead of showing modal
        onAuthRequired();
      }
    };

    window.addEventListener('userLogin', handleUserLogin);
    window.addEventListener('authError', handleAuthError);
    return () => {
      window.removeEventListener('userLogin', handleUserLogin);
      window.removeEventListener('authError', handleAuthError);
    };
  }, [showModal, onAuthRequired]);

  const handleLoginSuccess = (userData) => {
    setIsAuthenticated(true);
    setShouldShowModal(false);
    const modal = document.getElementById('authModal');
    if (modal && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
      try {
        const bsModal = bootstrap.Modal.getInstance(modal);
        if (bsModal) {
          bsModal.hide();
        }
      } catch (error) {
        console.error('Error hiding modal:', error);
      }
    }
  };

  const handleCloseModal = () => {
    if (redirectTo) {
      navigate(redirectTo);
    } else {
      navigate(-1); // Go back to previous page
    }
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated && !showModal) {
    return null;
  }

  return (
    <>
      {isAuthenticated ? children : null}
      
      {/* Authentication Modal */}
      <div className="modal fade" id="authModal" tabIndex="-1" aria-labelledby="authModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h5 className="modal-title" id="authModalLabel">Login Required</h5>
              {/* <button 
                type="button" 
                className="btn-close" 
                onClick={handleCloseModal}
                aria-label="Close"
              ></button> */}
            </div>
            <div className="modal-body">
              <div className="text-center mb-4">
                <p className="text-muted">Please log in to continue.</p>
              </div>
              <Form onLoginSuccess={handleLoginSuccess} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthCheck; 